import React, {useContext, useEffect, useState} from "react";
import {Grid, TextField, Typography, AlertTypes, MainLoader} from "@leap4/frontend";
import {OrganizationContext} from "./OrganizationContex";
import {IOrganizationPartners, PublisherLoginsContainer} from './AddEditOrganization/PublisherLogins.container'
import {IOrganizationAdvertiserLogin} from "../interfaces/IOrganizationAdvertiserLogin";
import {setAlert} from "../../../actions/alert";
import {getAllOrganizations} from "../../../actions/users";
import {useDispatch} from "react-redux";
import {ClientForm} from "./Client/ClientForm";



const DetailsForm = () => {
    const dispatch = useDispatch();
    const {organization, setOrganization} = useContext(OrganizationContext);

    const [allOrganizations, setAllOrganizations] = useState<IOrganizationAdvertiserLogin[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const updatePublisherLogins = (publisherLogins: IOrganizationPartners[]) => {
        let publisherLoginsForState = {}

        if (publisherLogins) {
            publisherLoginsForState = publisherLogins.reduce((acc: any, currVal) => {
                const organizationId: string = currVal.org._id
                acc[organizationId] = {
                    partners: currVal.selectedPartners,
                };
                return acc;
            }, {})
        }

        setOrganization({
            ...organization,
            advertiserLogin: publisherLoginsForState,
        })
    }

    const handleFormChange = (e: any) => {
        setOrganization({
            ...organization,
            name: e.target.value
        })
    }


    useEffect(() => {
        if (!organization._id) {
            setIsLoading(false)
            return;
        }
        let loadedOrganizations;
        (async () => {
            try {
                setIsLoading(true);
                loadedOrganizations = await getAllOrganizations(dispatch) as IOrganizationAdvertiserLogin[]
                setAllOrganizations(loadedOrganizations)
            } catch (err) {
                setAlert("Couldn't load organizations", AlertTypes.FAILURE)
            } finally {
                setIsLoading(false);
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return <Grid item padding={0}>
            <MainLoader/>
        </Grid>
    }

    return (
        <>
            <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5">
                {organization._id ? "ORGANIZATION INFO" : "CREATE ORGANIZATION "}
            </Typography>


            {!organization._id ? (
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="Organization name"
                    name="Organization name"
                    type="string"
                    autoComplete="email"
                    value={organization.name}
                    autoFocus
                    onChange={handleFormChange}

                />
            ) : (
            <Grid container gap={"10px"}>
            {organization?.name && <Grid item lg={12} width={"100%"}>
                <TextField fullWidth label={"Organization"} disabled value={organization?.name}/>
            </Grid>}
                <Grid item width='100%'>
                </Grid>
            </Grid>
            )}
            <Grid>
                <ClientForm
                    organizationId={organization._id}
                    dispatch={dispatch}
                />
            </Grid>
            {!organization._id ? (<>
            </>) : (
            <PublisherLoginsContainer allOrganizations={allOrganizations}
                                      updatePublisherLogins={updatePublisherLogins}
                                      currentOrganization={organization}
            />
            )}
        </>
    )
}

export {DetailsForm}


